import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { displayUserName } from '../../../../services/utilityFunctions';
import ServerSideCarousel from '../../../../commonComponents/carousel/ServerSideCarousel';
import Carousel from '../../../../commonComponents/carousel/Carousel';

function MyRatings({ owner }) {
  return (
    <div>
      <Carousel>
      <ServerSideCarousel
        id="my-ratings-carousel"
        fetchUrl={`/table/rating/list/average?populate=user&owner=${owner}`}
        defaultFetchError="profile.performance.perform.error.ratings"
        fetchHeaders={{
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
          'Content-Type': 'application/json',
        }}
      >
        {items =>
          items.map(rating => {
            const { user, value } = rating;
            const { image } = user;
            const userName = displayUserName(user);
            const userImage = image && image.thumb ? image.thumb : '/images/no_user.png';

            return (
              <div className="col-lg-2 col-6 my-ratings-performance">
                <div className="my-ratings-performance-image">
                  <img src={userImage} alt={userName} />
                </div>
                <div className="my-ratings-performance-username">{userName}</div>
                <div className="my-ratings-performance-value">
                  <img
                    src={
                    value >= 1 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
                  }
                    alt={value}
                  />
                  <img
                    src={
                      value >= 2 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
                    }
                    alt={value}
                  />
                  <img
                    src={
                      value >= 3 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
                    }
                    alt={value}
                  />
                  <img
                    src={
                      value >= 4 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
                    }
                    alt={value}
                  />
                  <img
                    src={
                      value === 5 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
                    }
                    alt={value}
                  />
                </div>
              </div>
            );
          })
        }
      </ServerSideCarousel>
      </Carousel>
    </div>
  );
}

MyRatings.propTypes = {
  owner: PropTypes.string.isRequired,
};

export default translate(MyRatings);
